export default __webpack_public_path__ + "static/media/arrow-left.6bbc9984.svg";